// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'lib-flexible'
import 'babel-polyfill'
import promise from 'es6-promise'
import store from './store'
promise.polyfill()
// import InitSFFUIPlugin from './plugins/InitSFFUIPlugin'
// import mixin from './mixins/global-mixin'
// Vue.mixin(mixin)
// Vue.use(InitSFFUIPlugin)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js